import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';

const BASE_URL = COMMUNITY_ENDPOINTS.LEGAL;

export const getAll = (params = {}) =>
  communityHttpClient.get(`${BASE_URL}/`, { params });

export const getById = (id) =>
  communityHttpClient.get(`${BASE_URL}/${id}/`);

export const getCurrent = (documentType) =>
  communityHttpClient.get(`${BASE_URL}/current/${documentType}/`);

export const create = (data) =>
  communityHttpClient.post(`${BASE_URL}/`, data);

export const update = (id, data) =>
  communityHttpClient.put(`${BASE_URL}/${id}/`, data);

export const remove = (id) =>
  communityHttpClient.delete(`${BASE_URL}/${id}/`);

export default {
  getAll,
  getById,
  getCurrent,
  create,
  update,
  delete: remove,
  remove
};
